<template>
  <div class="nav_wrap">
    <div class="nav_cont">
      <div class="nav_left" @click.stop="gotoHome">
        <div class="nav_lview">
          <div class="nav_limg">
            <img src="../assets/image/nav_logo1.png" />
          </div>
        </div>
      </div>
      <div class="nav_right">
        <div class="nav_rview">
          <span>INICIO</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "./scss/nav.scss";

  export default {
    name: "headNav",
    data() {
      return {

      };
    },
    created() {

    },
    methods: {
      gotoHome() {
        this.$router.push('/home');
      }
    },
  };
</script>

<style>
</style>
